var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "tableSort",
                  attrs: { data: _vm.list, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      align: "center",
                      width: "80",
                      prop: "seq",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "开庭时间", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.hearing_date || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "案由" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.cause_action || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "案号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.case_no || "-") + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "原告/上诉人/申请人" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.plainTiffFieldName || "-") +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "被告/被上诉人/被申请人" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.defendantFieldName || "-") +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "100px",
                      fixed: "right",
                      align: "center",
                      fit: "true",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "查看详情",
                                  placement: "top-start",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-document",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDetail(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.total > 0
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 12, lg: 24, xl: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.queryForm.pageNum,
                          "page-size": _vm.queryForm.pageSize,
                          background: _vm.background,
                          total: _vm.total,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "开庭公告详情",
            visible: _vm.flag,
            "close-on-click-modal": false,
            width: "55%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.flag = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "table",
            {
              staticClass: "info-table",
              staticStyle: { width: "100%", height: "100%" },
              attrs: { cellspacing: "0" },
            },
            [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("开庭日期")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.hearing_date || "-"))]),
                  _c("td", [_vm._v("案号")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.case_no || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("案由")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.cause_action || "-"))]),
                  _c("td", [_vm._v("承办部门")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.court || "-"))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("审判长或主审人")]),
                  _c("td", [_vm._v(_vm._s(_vm.report.judge || "-"))]),
                  _c("td", [_vm._v("原告/上诉人/申请人")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.report.plainTiffFieldName || "-")),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("被告/被上诉人/被申请人")]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.report.defendantFieldName || "-")),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }